import React from "react";
import App from "../Component/App";

const Applaunch = () => {
  return (
    <>
      <App /> //Used the Tshirt component here
    </>
  );
};

export default Applaunch;
